export const priceCategories = [
  {
    "id": "8",
    "vector_id": "7",
    "title": "Программные продукты 1С:Предприятие 8, электронные поставки",
    "date": "2024-09-10 13:57:19"
  },
  {
    "id": "9",
    "vector_id": "7",
    "title": "Программные продукты 1С:Предприятие 8 с программной защитой",
    "date": "2024-09-10 21:15:08"
  },
  {
    "id": "10",
    "vector_id": "7",
    "title": "Программные продукты 1С:Предприятие 8 с аппаратной защитой, учебные и базовые версии",
    "date": "2024-09-11 12:17:35"
  },
  {
    "id": "11",
    "vector_id": "7",
    "title": "Лицензии 1С:Предприятие 8, электронные поставки",
    "date": "2024-09-11 13:38:02"
  },
  {
    "id": "12",
    "vector_id": "7",
    "title": "Лицензии 1С:Предприятие 8 с аппаратной защитой",
    "date": "2024-09-11 13:38:15"
  },
  {
    "id": "13",
    "vector_id": "7",
    "title": "Совместные отраслевые продукты и лицензии для 1С:Предприятия",
    "date": "2024-09-11 13:38:30"
  },
  {
    "id": "14",
    "vector_id": "7",
    "title": "Лицензии 1С:Предприятие 8 с программной защитой",
    "date": "2024-09-11 13:38:44"
  }
]
